import { render, staticRenderFns } from "./Reviewer.vue?vue&type=template&id=adf8e4d8&scoped=true&"
import script from "./Reviewer.vue?vue&type=script&lang=js&"
export * from "./Reviewer.vue?vue&type=script&lang=js&"
import style0 from "./Reviewer.vue?vue&type=style&index=0&id=adf8e4d8&prod&lang=css&"
import style1 from "./Reviewer.vue?vue&type=style&index=1&id=adf8e4d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf8e4d8",
  null
  
)

export default component.exports